// @flow
import './default-bundle';

import SaveForLaterLink from '@components/cart/SaveForLaterLink';
import AddDiamondToSettingLink from '@components/cart/AddDiamondToSettingLink';
import AddMatchingBandLink from '@components/cart/AddMatchingBandLink';
import CheckoutSteps from '@components/cart/CheckoutSteps';
import ReceivedItemsFooter from '@components/ReceivedItemsFooter';
import CartTotals from '@components/cart/CartTotals';

ReactOnRails.register({
  SaveForLaterLink,
  AddDiamondToSettingLink,
  AddMatchingBandLink,
  CheckoutSteps,
  ReceivedItemsFooter,
  CartTotals
});
